var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Bar',{ref:"barCharts",attrs:{"chart-data":_vm.chartDatas,"chart-options":_vm.chartOptions,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }